<template>
  <va-edit-layout :actions="['list', 'show', 'delete']">
    <soil-mgmts-form :id="id" :title="title" :item="item"></soil-mgmts-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ['id', 'title', 'item'],
}
</script>
